import type { PlaywrightLogEntry, PlaywrightTest } from "./playwright-api";

export const testRowKey = (test: Pick<PlaywrightTest, "id" | "testKey">) =>
  test.testKey || test.id;

export const selectedTests = (
  tests: PlaywrightTest[],
  keys: string[]
) => tests.filter((test) => keys.includes(testRowKey(test)));

export const entryMatchesSelectedTests = (
  entry: PlaywrightLogEntry,
  tests: PlaywrightTest[]
) => {
  if (tests.length === 0) return true;
  return tests.some((test) => {
    const key = testRowKey(test);
    if (entry.testKey) return entry.testKey === key;
    return entry.spec === test.spec && entry.test === test.title;
  });
};

export const isIdentityLogLabel = (label: string) =>
  label.startsWith("test:") || label.startsWith("spec:");

export const testKeyForLogEntry = (
  entry: PlaywrightLogEntry,
  tests: PlaywrightTest[]
) => {
  const match = tests.find((test) => {
    if (entry.testKey) return entry.testKey === testRowKey(test);
    return entry.spec === test.spec && entry.test === test.title;
  });
  return match ? testRowKey(match) : null;
};
